import React from 'react';
import propTypes from 'prop-types';

import style from './index.less';

function Status({ children, color = 'green' }) {

  return (
    <div className={`${style.status} ${color}`}>
      <span>{children}</span>
    </div>
  );
}

Status.propTypes = {
  color: propTypes.oneOf(['red', 'blue', 'green'])
};

export default Status;
